const prediggoTranslation = {
    mainVegetable: 'vegetables',
    'mainVegetable/01': 'vegetables/aubergines',
    'mainVegetable/02': 'vegetables/asparagus',
    'mainVegetable/03': 'vegetables/avocado',
    'mainVegetable/04': 'vegetables/beets',
    'mainVegetable/05': 'vegetables/broccoli',
    'mainVegetable/06': 'vegetables/carrots',
    'mainVegetable/07': 'vegetables/celery',
    'mainVegetable/08': 'vegetables/mushrooms',
    'mainVegetable/09': 'vegetables/cabbage',
    'mainVegetable/10': 'vegetables/brussels-sprouts',
    'mainVegetable/11': 'vegetables/chinese-cabbage',
    'mainVegetable/12': 'vegetables/cauliflower',
    'mainVegetable/13': 'vegetables/coleslaw',
    'mainVegetable/14': 'vegetables/cucumber',
    'mainVegetable/15': 'vegetables/zucchini',
    'mainVegetable/16': 'vegetables/endives',
    'mainVegetable/17': 'vegetables/spinach',
    'mainVegetable/18': 'vegetables/fava-beans',
    'mainVegetable/19': 'vegetables/flageolets',
    'mainVegetable/20': 'vegetables/flat-beans',
    'mainVegetable/21': 'vegetables/dry-beans',
    'mainVegetable/22': 'vegetables/green-beans',
    'mainVegetable/23': 'vegetables/lenses',
    'mainVegetable/24': 'vegetables/macedoine',
    'mainVegetable/25': 'vegetables/mais',
    'mainVegetable/26': 'vegetables/mesclun',
    'mainVegetable/27': 'vegetables/turnips',
    'mainVegetable/28': 'vegetables/onions',
    'mainVegetable/29': 'vegetables/peas-soya',
    'mainVegetable/30': 'vegetables/peppers',
    'mainVegetable/31': 'vegetables/potatoes-and-potatoes',
    'mainVegetable/32': 'vegetables/soybean-sprouts',
    'mainVegetable/33': 'vegetables/radishes',
    'mainVegetable/34': 'vegetables/oak-leaf-salad',
    'mainVegetable/35': 'vegetables/frisee-salad',
    'mainVegetable/36': 'vegetables/salade-iceberg',
    'mainVegetable/37': 'vegetables/piedmontese-salad',
    'mainVegetable/38': 'vegetables/rice-salad',
    'mainVegetable/39': 'vegetables/roman-salad',
    'mainVegetable/40': 'vegetables/young-shoots',
    'mainVegetable/41': 'vegetables/lettuce',
    'mainVegetable/42': 'vegetables/lambs-lettuce',
    'mainVegetable/43': 'vegetables/arugula',
    'mainVegetable/44': 'vegetables/salsifies',
    'mainVegetable/45': 'vegetables/taboule',
    'mainVegetable/46': 'vegetables/tomatoes',
    'mainVegetable/47': 'vegetables/buttered-bean',
    'mainVegetable/48': 'vegetables/chickpea',
    'mainVegetable/49': 'vegetables/leeks',
    'mainVegetable/50': 'vegetables/pumpkin',
    'mainVegetable/51': 'vegetables/kidney-bean',
    'mainVegetable/52': 'vegetables/apples',
    'mainVegetable/53': 'vegetables/chestnuts',
    'mainVegetable/54': 'vegetables/prunes',
    'mainVegetable/55': 'vegetables/gardener',
    'mainVegetable/56': 'vegetables/black-olives',
    'mainVegetable/57': 'vegetables/artichokes',
    'mainVegetable/58': 'vegetables/red-peppers',
    'mainVegetable/59': 'vegetables/green-peppers',
    'mainVegetable/60': 'vegetables/spring',
    'mainVegetable/61': 'vegetables/ratatouille',
    'mainVegetable/62': 'vegetables/couscous',
    'mainVegetable/63': 'vegetables/tagine',
    'mainVegetable/64': 'vegetables/curry-vegetables',
    'mainVegetable/65': 'vegetables/pea-cups',
    'mainVegetable/67': 'vegetables/coral-lenses',
    'mainVegetable/68': 'vegetables/quinoa',
    'mainVegetable/69': 'vegetables/spelt',
    'mainVegetable/70': 'vegetables/bulgur',
    'mainVegetable/71': 'vegetables/red-cabbage',
    'mainVegetable/72': 'vegetables/kale',
    'mainVegetable/73': 'vegetables/chervil',
    'mainVegetable/74': 'vegetables/grains-and-seeds',
    'mainVegetable/75': 'vegetables/legume',
    'mainVegetable/76': 'vegetables/sweet-potato',
    'mainVegetable/77': 'vegetables/pumpkins',
    'mainVegetable/78': 'vegetables/dough',
    'mainVegetable/79': 'vegetables/beans',
    'mainVegetable/80': 'vegetables/pea-carrots',
    'mainVegetable/81': 'vegetables/peas',
    season: 'seasons',
    'season/1': 'seasons/summer',
    'season/2': 'seasons/autumn',
    'season/3': 'seasons/winter',
    'season/4': 'seasons/spring',
    technologie: 'technology',
    'technologie/AC01': 'technology/preserve',
    'technologie/AD01': 'technology/frozen',
    'technologie/AG01': 'technology/fresh',
    'technologie/AT01': 'technology/caterer',
    recipeDish: 'type',
    'recipeDish/ACC': 'type/accompaniment',
    'recipeDish/APE': 'type/aperitif',
    'recipeDish/PLAT': 'type/dish',
    'recipeDish/DES': 'type/dessert',
    'recipeDish/ENT': 'type/entrance',
    'recipeDish/SAL': 'type/salad',
    'recipeDish/SNA': 'type/snack-bar',
    'recipeDish/PDE': 'type/breakfast',
    'recipeDish/DEJ': 'type/lunch',
    'pred-recipeTimingCook-facet': 'baking',
    'pred-recipeTimingCook-facet/0%20-%2015%20min': 'baking/0-15-minutes',
    'pred-recipeTimingCook-facet/15%20-%2030%20min': 'baking/15-30-minutes',
    'pred-recipeTimingCook-facet/30%20-%2045%20min': 'baking/30-45-minutes',
    'pred-recipeTimingCook-facet/45%20min%20and%20more': 'baking/45-minutes',
    'pred-recipeTimingPreparation-facet': 'preparation',
    'pred-recipeTimingPreparation-facet/0%20-%2015%20min': 'preparation/0-15-minutes',
    'pred-recipeTimingPreparation-facet/15%20-%2030%20min':
      'preparation/15-30-minutes',
    'pred-recipeTimingPreparation-facet/30%20-%2045%20min':
      'preparation/30-45-minutes',
    'pred-recipeTimingPreparation-facet/45%20min%20and%20more':
      'preparation/45-minutes',
    'pred-recipeCost-Facet': 'budget',
    'pred-recipeCost-Facet/petit': 'budget/cheap',
    'pred-recipeCost-Facet/moyen': 'budget/medium',
    'pred-recipeCost-Facet/grand': 'budget/high',
    recipeDifficulty: 'difficulte',
    'recipeDifficulty/1': 'difficulte/easy',
    'recipeDifficulty/2': 'difficulte/medium',
    'recipeDifficulty/3': 'difficulte/elaborate',
    recipeDishNumber: 'guest',
    'recipeDishNumber/1': 'guest/1',
    'recipeDishNumber/5': 'guest/2',
    'recipeDishNumber/6': 'guest/2',
    'recipeDishNumber/58': 'guest/3',
    'recipeDishNumber/60': 'guest/3',
    'recipeDishNumber/62': 'guest/4',
    'recipeDishNumber/64': 'guest/4',
    'recipeDishNumber/302': 'guest/5',
    'recipeDishNumber/309': 'guest/5',
    'recipeDishNumber/305': 'guest/6',
    'recipeDishNumber/312': 'guest/7',
    // 'recipeDishNumber/7': 'convive/7',
    'recipeDishNumber/322': 'guest/8',
    'recipeDishNumber/329': 'guest/8',
    'productRange': 'ranges',
    'productRange/BEAN_SAUCE': 'ranges/beans-in-sauce',
    'productRange/BEANS': 'ranges/beans',
    'productRange/BIO': 'ranges/bio',
    'productRange/BOND_KIDS': 'ranges/bonduelle-kids',
    'productRange/CARTA_DELL': 'ranges/carta-delle-insalate',
    'productRange/CEREAL_CAN': 'ranges/cereals-ambient',
    'productRange/CEREAL_FRZ': 'ranges/cereals-frozen',
    'productRange/CEREALI': 'ranges/cereals',
    'productRange/CEREALLEGR': 'ranges/cereallegre',
    'productRange/COCCOLE': 'ranges/coccole',
    'productRange/CORN': 'ranges/corn',
    'productRange/FRANCAIS': 'ranges/100-french',
    'productRange/INSALATE-D': 'ranges/insalate-degli-agricoltori',
    'productRange/LE_REGIONA': 'ranges/le-regionali',
    'productRange/LEGUMIO': 'ranges/legumio',
    'productRange/MIXES_CORN': 'ranges/mixes-with-corn',
    'productRange/MONO_VEGE': 'ranges/mono-vegetables',
    'productRange/MUSHROOMS': 'ranges/mushroom',
    'productRange/NATURA_IN': 'ranges/natura-in-padella',
    'productRange/OTHER_VEG': 'ranges/other-vegetables',
    'productRange/PEAS': 'ranges/peas',
    'productRange/SOUPS': 'ranges/veggie-for-soups',
    'productRange/SPINACH': 'ranges/spinach',
    'productRange/STEAM_CAN': 'ranges/steam-can',
    'productRange/STEAM_FRZ': 'ranges/steam-frozen',
    'productRange/STUZZICHIA': 'ranges/stuzzichiamo',
    'productRange/TOUCHE': 'ranges/enricher',
    'productRange/TUS_RECETA': 'ranges/your-recipes',
    'productRange/VEG_TO_FRY': 'ranges/vegetables-to-fry',
    'productRange/VEGGIE': 'ranges/veggie-rice',
    'productRange/STEAM_MIX': 'ranges/steam-frozen-mixes',
    'productRange/CREATIF': 'ranges/creatif',
    'productRange/READY_FROZ': 'ranges/ready-frozen-meals',
    'cultureType': 'culture-type',
    'cultureType/Sans%20r%E9sidu%20de%20pesticide': 'culture-type/no-pesticide-residue',
    'cultureType/Sans%20OGM': 'culture-type/gmo-free',
    'cultureType/Bio': 'culture-type/bio',
  };
  
  export default prediggoTranslation;